<template>
    <div class="form-field-filter-group-mobile border-t border-gray-200 px-4 py-6">
        <h3 class="-mx-2 -my-3 flow-root">
            <!-- Expand/collapse section button -->
            <button
                @click="toggleOpen"
                type="button"
                class="flex w-full items-center justify-between bg-white px-2 py-3 text-sm text-gray-400"
                aria-controls="filter-section-0" aria-expanded="false"
            >
                <span class="font-medium text-gray-900">{{ label }}</span>
                <span class="ml-6 flex items-center">
                    <svg
                        class="h-5 w-5 transform"
                        :class="{
                            'rotate-0': !open,
                            'rotate-180': open,
                        }"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path fill-rule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                              clip-rule="evenodd" />
                    </svg>
                </span>
            </button>
        </h3>
        <!-- Filter section, show/hide based on section state. -->
        <div
            class="pt-6"
            id="filter-section-0"
            :class="{
                'hidden': !open,
                'block': open,
            }"
        >
            <div class="space-y-6">
                <div class="flex items-center" v-for="item in items" :key="item.value">
                    <input
                        class="h-4 w-4 rounded border-gray-300 text-sky-600 focus:ring-sky-500"
                        @input="toggle(item.value)"
                        v-model="selected"
                        :id="`${name}-${item.value}-checkbox`"
                        :name="`${name}[]`"
                        :value="item.value"
                        type="checkbox"
                    >
                    <label
                        :for="`${name}-${item.value}-checkbox`"
                        class="ml-3 text-sm text-gray-500"
                    >
                        {{ item.text }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FormFieldFilterGroupMobile',
    emits: ['input'],
    data () {
        return {
            open: false,
            selected: this.value,
        };
    },
    props: {
        items: {
            required: false,
            type: Array,
            default: function () {
                return [
                    // {value: '', text: ''}
                ];
            }
        },
        label: {
            required: false,
            type: String,
            default: 'Select Options',
        },
        name: {
            required: true,
            type: String,
        },
        value: {
            required: false,
            type: Array,
            default: function () {
                return [];
            },
        }
    },
    methods: {
        toggleOpen () {
            this.open = !this.open;
        },
        toggle (value) {
            const isSelected = this.selected.includes(value);
            const selected = this.selected.filter(item => item !== value);
            if (!isSelected) selected.push(value);
            this.selected = selected;
            this.$emit('input', {name: this.name, value: this.selected});
        }
    },
    watch: {
        value (value) {
            this.selected = value;
        }
    },
};
</script>
